import React from "react";
import { IconButton, Box } from "@mui/material";
import FormLabel from "./FormLabel";

export default function IconToggle({
  value,
  onChange,
  checkedIcon: Checked,
  uncheckedIcon: Unchecked,
  color = "primary",
  size = 24,
  height = 40,
  width = 40,
  sx = {},
  label,
  gap = 24,
}) {
  if (!Checked || !Unchecked) {
    console.error("Invalid icon provided to IconToggle");
    return null;
  }

  return (
    <Box
      sx={{
        height,
        width,
        display: "flex",
        flexDirection: "column", // ⭐ Put label ABOVE icon
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 0.5, // space between label & icon
        ...sx,
      }}
    >
      <FormLabel label={label} gap={gap} />
      <IconButton
        onClick={() => onChange(!value)}
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 2,
          padding: 0,
        }}
      >
        {value ? (
          <Checked color={color} style={{ fontSize: size }} />
        ) : (
          <Unchecked color={color} style={{ fontSize: size }} />
        )}
      </IconButton>
    </Box>
  );
}
